export default __webpack_public_path__ + "static/media/avatar.8f1fc2c1.png";